import {DateRangePicker, LocalizationProvider} from "@mui/x-date-pickers-pro";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import locale from "date-fns/locale/hu";
import {Stack, TextField} from "@mui/material";
import React from "react";

const CustomDateRangePicker = ({errors, setErrors, data, setData, name, validators, ...rest}) => {
    const [startName, endName] = name.split('|')

    const handleDateChange = (newValue) => {
        const [start, end] = newValue
        setData({...data, [startName]: start, [endName]: end})
    };

    const handleStartBlur = e => {
        for (let validator of validators[startName]) {
            const {valid, error} = validator(e.target.value);
            if (!valid) {
                setErrors({...errors, [startName]: error})
                break
            } else setErrors({...errors, [startName]: ''})
        }
    }

    const handleEndBlur = e => {
        for (let validator of validators[endName]) {
            const {valid, error} = validator(e.target.value)
            if (!valid) {
                setErrors({...errors, [endName]: error})
                break
            } else setErrors({...errors, [endName]: ''})
        }
    }


    return <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale} localeText={{start: 'Rendelés kezdete', end: 'Rendelés vége'}}>
        <DateRangePicker
            value={[data?.[startName], data?.[endName]]||[]}
            onChange={handleDateChange}
            inputFormat="yyyy-MM-dd"
            renderInput={(startProps, endProps) => (
                <Stack spacing={2} direction={{xs: 'column', md: 'row'}} sx={{width: '100%'}}>
                    <TextField sx={{width: '100%'}} onBlur={handleStartBlur} {...startProps} error={Boolean(errors[startName])} helperText={errors[startName]} />
                    <TextField sx={{width: '100%'}} onBlur={handleEndBlur} {...endProps} error={Boolean(errors[endName])} helperText={errors[endName]}/>
                </Stack>
            )}
            {...rest}
        />
    </LocalizationProvider>
}

export default CustomDateRangePicker